<script setup lang="ts">
const { t: $t } = useI18n()

import type { NuxtError } from '#app'

const props = defineProps<{ error: NuxtError }>()

const errorMessage = computed(() => {
  return props.error.status === 404 ? $t('error404Description') : $t('error500Description')
})
</script>

<template>
  <div class="flex h-screen w-screen flex-col items-center justify-center text-center text-black">
    <img src="/images/logo-fletcher.svg" alt="Fletcher Menu" class="mb-8 w-80">

    <h1 class="text-3xl font-bold">
      {{ error.status }}
    </h1>
    <p class="mb-4">
      {{ errorMessage }}
    </p>
    <NuxtLink to="/" class="underline">
      {{ $t('backToHome') }}
    </NuxtLink>
  </div>
</template>
